import React from "react";
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Hero, Section, Cards, CTA, Steps, FAQ, ProofBand } from "../components/Page/Page.js";
import { audiences } from "../data/content.js";

export default function AudienceScreen({ kind }) {
  const a = audiences.find((x) => x.slug === kind);
  if (!a) return <Navigate to="/404" replace />;
  return (
    <>
      <Hero title={a.title} text={a.tagline} cta="Book a discovery call" />
      <Section><p>{a.intro}</p></Section>
      {kind === "buyers" && <Section><p><Link to="/buyers/guide">Read the first-time buyer guide →</Link></p></Section>}
      {kind === "sellers" && <Section><p><Link to="/sellers/list">List your project →</Link></p></Section>}
      <Section title="What you get" alt><Cards items={a.points} /></Section>
      <Section title="How it works"><Steps /></Section>
      <ProofBand />
      <Section title="Questions"><FAQ items={a.faq} /></Section>
      <CTA text={a.cta + "?"} />
    </>
  );
}
